<template>
  <UiOnClickOutside :do="hideContent">
    <div class="ui-base-menu-dropdown component">
      <div class="icon-wrapper">
        <div>
          <img src="../assets/default-avatar.png" alt="avatar" />
        </div>
        <div class="personal-info">
          <span class="name">{{ currentUser.username }}</span>
          <span class="role">({{ getRoleUser() }})</span>
          <div @click="toggleMenu">{{ getCurrenStore(currenStore) }} <UiBaseIcon iconName="arrowDown" height="18" width="18" /> </div>
        </div>
      </div>
      <div class="content" v-if="isShown" @click="hideContent">
        <ul>
          <li v-for="store in listStore" :key="store.id" @click="changeStore(store.id, store.type, store.store_external_id)">{{ store.url }}</li>
          <li class="signout" @click="$emit('logout')">
            <div>{{ $t("sign_out") }}</div>
          </li>
        </ul>
      </div>
    </div>
  </UiOnClickOutside>
</template>

<script>
import { mapGetters } from 'vuex'
import UiOnClickOutside from './UiOnClickOutside'
import UiBaseIcon from '@/components/icons/UiBaseIcon'

export default {
  name: 'UiUserDropdown',
  props: {
    autoClose: {
      type: Boolean,
      default: true
    },
    listStore: {
      type: Array,
      default: () => []
    },
    currentUser: {
      type: Object,
      default: () => {}
    },
    currenStore: {
      type: String,
      default: null
    }
  },

  components: {
    UiOnClickOutside,
    UiBaseIcon
  },

  data () {
    return {
      isShown: false
    }
  },
  computed: {
    ...mapGetters({
      currenStoreData: 'user/getCurrenStore'
    })
  },
  methods: {
    toggleMenu () {
      this.isShown = !this.isShown
    },
    hideContent () {
      if (this.isShown) this.isShown = false
    },
    changeStore (storeId, type, storeExternalId) {
      this.$emit('changeStore', storeId, type, storeExternalId)
    },
    getCurrenStore (storeId) {
      const id = storeId || this.currenStoreData
      const store = this.listStore.find(store => store.id === id)
      if (store) {
        return store.url
      }
      return 'No store'
    },
    getRoleUser () {
      let roles = ''
      this.currentUser.roles.forEach((roleName, index) => {
        if (index === 0) {
          roles = roleName
        } else {
          roles = `${roles},${roleName}`
        }
      })
      return roles
    }
  }
}
</script>

<style lang="scss">
.ui-base-menu-dropdown.component {
  display: flex;
  position: relative;
  .default-menu-icon {
    cursor: pointer;
    .line {
      margin: 2px 0;
      width: 25px;
      height: 4px;
      background-color: #cccccc;
    }
  }
  .icon-wrapper {
    display: flex;
    align-items: center;
    font-size: 13px;
    .personal-info {
      margin-left: 10px;
      text-transform: lowercase;
      .name {
        color: #11b4a8;
        margin-right: 5px;
      }
      .role {
        color: #4f4f4f;
      }
    }
    div {
      margin-top: 5px;
      cursor: pointer;
    }
  }
  .content {
    min-width: 150px;
    border: 1px solid $color-black-transparent;
    border-radius: 4px;
    padding: 5px 0;
    padding-bottom: 0;
    position: absolute;
    top: 100%;
    right: 0;
    background-color: $color-white;
    text-transform: lowercase;
    ul li {
      display: block;
      word-break: break-word;
      white-space: nowrap;
      border-bottom: 1px solid #ccd4d9;
      padding: 15px;
      color: #333;
      &:hover {
        background-color: $color-black-transparent;
        cursor: pointer;
      }
      a {
        color: inherit;
        display: block;
      }
    }
    .signout {
      background: #3a465c;
      padding: 15px 0;
      text-transform: uppercase;
      text-align: center;
      color: #30a59c;
      font-weight: 600;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
</style>
